import React from 'react';
import { API_BASE_URL } from '../config/api';

const GoogleIcon: React.FC = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 8 3l5.7-5.7C34.2 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.5-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16.1 19 13 24 13c3.1 0 5.8 1.1 8 3l5.7-5.7C34.2 6.1 29.4 4 24 4 16.3 4 9.6 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.1 35.2 26.7 36 24 36c-5.3 0-9.7-3.1-11.3-7.5l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-1.1 3.1-3.6 5.5-6.7 6.7l.1.1 6.2 5.2C36.9 41.1 44 36 44 24c0-1.3-.1-2.5-.4-3.5z" />
  </svg>
);

interface GoogleAuthButtonProps {
  mode?: 'login' | 'signup';
  disabled?: boolean;
  label?: string;
}

const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({
  mode = 'login',
  disabled = false,
  label,
}) => {
  const handleClick = () => {
    if (disabled) return;
    // API_BASE_URL already ends in /api ('/api' on cPanel, or 'https://host/api' when overridden),
    // so only the route below it is appended. Adding '/api' again produced /api/api/auth/google.
    window.location.href = `${API_BASE_URL}/auth/google?mode=${mode === 'signup' ? 'signup' : 'login'}`;
  };

  return (
    <button
      type="button"
      className="google-auth-btn"
      onClick={handleClick}
      disabled={disabled}
    >
      <GoogleIcon />
      <span>{label || (mode === 'signup' ? 'Sign up with Google' : 'Continue with Google')}</span>
    </button>
  );
};

export default GoogleAuthButton;
